module.exports = "<h4>Search results...</h4>"